import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import MyPlayerModel from '../models/MyPlayerModel';

export type TABLE_TYPE = Table<MyPlayerModel>;

export const TABLE = 'myPlayer';
const SCHEMA = 'playerId';

export class MyPlayerRepo implements DataRepository<MyPlayerModel> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<MyPlayerModel | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: MyPlayerModel): Promise<MyPlayerModel> {
    return this.db[TABLE].put(payload);
  }

  async bulkAdd(payload: MyPlayerModel[]): Promise<MyPlayerModel[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<MyPlayerModel[]> {
    return this.db[TABLE].toArray();
  }

  add(player: MyPlayerModel): Promise<MyPlayerModel> {
    return this.update(player);
  }
}

export const MyPlayerDB = new MyPlayerRepo(db);
